import React, { createContext, useContext, useState } from "react";
import ConfirmationModal from "../components/confirmationModal";

const ConfirmationContext = createContext();

export const ConfirmationProvider = ({ children }) => {
  const [confirmationState, setConfirmationState] = useState({
    show: false,
    title: "",
    description: "",
    confirmText: "",
    cancelText: "",
    variant: "primary",
    onConfirm: () => {},
  });

  const showConfirmation = (config) => {
    setConfirmationState({
      ...confirmationState,
      ...config,
      show: true,
    });
  };

  const hideConfirmation = () => {
    setConfirmationState({
      ...confirmationState,
      show: false,
    });
  };

  return (
    <ConfirmationContext.Provider value={{ showConfirmation }}>
      {children}
      <ConfirmationModal
        show={confirmationState.show}
        onHide={hideConfirmation}
        onConfirm={() => {
          confirmationState.onConfirm();
          hideConfirmation();
        }}
        title={confirmationState.title}
        description={confirmationState.description}
        confirmText={confirmationState.confirmText}
        cancelText={confirmationState.cancelText}
        variant={confirmationState.variant}
      />
    </ConfirmationContext.Provider>
  );
};

export const useConfirmation = () => useContext(ConfirmationContext);
